(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-deferred-reviews')) {
    customElements.define('coverly-deferred-reviews', class extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('template[data-coverly-review-content]');
        if (!this.content || this.started) return;
        this.started = true;
        this.isReviewHash = hash => hash === '#looxReviews' || hash === '#looxReviewsFrame';
        this.onHash = () => {
          if (this.isReviewHash(location.hash)) this.reveal(true);
        };
        this.onLink = event => {
          const link = event.target.closest?.('a[href]');
          if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const url = new URL(link.href, location.href);
          if (url.origin === location.origin && url.pathname === location.pathname && this.isReviewHash(url.hash)) this.reveal(url.hash === '#looxReviewsFrame');
        };
        document.addEventListener('click', this.onLink, true);
        window.addEventListener('hashchange', this.onHash);
        if (this.isReviewHash(location.hash)) this.reveal(true);
        else if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) this.reveal();
          }, { rootMargin: '800px 0px' });
          this.observer.observe(this);
        } else this.reveal();
      }
      reveal(scroll = false) {
        if (!this.content) return;
        const content = this.content;
        this.content = null;
        this.replaceChildren(content.content.cloneNode(true));
        this.dataset.loaded = 'true';
        this.observer?.disconnect();
        if (scroll) requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('click', this.onLink, true);
        window.removeEventListener('hashchange', this.onHash);
        this.started = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-component-explorer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('coverly-component-explorer'))customElements.define('coverly-component-explorer',class extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
  this.dialog=this.querySelector('dialog');this.host=this.querySelector('[data-viewer-host]');this.loading=this.querySelector('.cce-loading');this.fallback=this.querySelector('[data-fallback]');
  this.querySelectorAll('[data-launch]').forEach(button=>button.addEventListener('click',()=>this.open(button),{signal}));
  this.querySelectorAll('[data-frame-family-choice]').forEach(button=>button.addEventListener('click',()=>{
   this.dataset.frameFamily=button.dataset.frameFamilyChoice;
   this.querySelectorAll('[data-frame-family-choice]').forEach(choice=>choice.setAttribute('aria-pressed',String(choice===button)));
  },{signal}));
  this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('close',()=>this.cleanup(),{signal});
  window.addEventListener('message',event=>{
   if(!this.frame||event.source!==this.frame.contentWindow||event.origin!==this.viewerOrigin)return;
   if(event.data?.type==='coverly:component-close'||(this.dataset.profile==='zeroglow'&&event.data?.type==='coverly:escape'))this.dialog.close();
   if(event.data?.type==='coverly:component-ready'||(this.dataset.profile==='zeroglow'&&event.data?.type==='coverly:ready')){this.loading.hidden=true;clearTimeout(this.timer);}
   if(event.data?.type==='coverly:frame-guide-state'&&event.data.guide===this.dataset.frameGuide&&['hybrid','wood'].includes(event.data.family)){
    const choices=[...this.querySelectorAll('[data-frame-family-choice]')];
    if(choices.some(choice=>choice.dataset.frameFamilyChoice===event.data.family)){
     this.dataset.frameFamily=event.data.family;
     choices.forEach(choice=>choice.setAttribute('aria-pressed',String(choice.dataset.frameFamilyChoice===event.data.family)));
    }
   }
  },{signal});
 }
 open(button){
  if(this.dialog.open)return;this.opener=button;
  this.querySelector('.cce-error').hidden=true;this.loading.hidden=false;this.fallback.hidden=true;this.querySelector('.cce-spinner').hidden=false;
  this.dialog.showModal();this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
  let url;try{url=new URL(this.dataset.url);if(url.protocol!=='https:'&&!(url.protocol==='http:'&&['127.0.0.1','localhost'].includes(url.hostname)))throw Error('Invalid viewer URL');}catch{this.loading.hidden=true;this.querySelector('.cce-error').hidden=false;return;}
  url.searchParams.set('profile',this.dataset.profile);url.searchParams.set('embed','1');url.searchParams.set('parentOrigin',location.origin);
  if(button.dataset.part)url.searchParams.set('part',button.dataset.part);else url.searchParams.delete('part');
  if(this.dataset.frameGuide){
   url.searchParams.set('frameGuide',this.dataset.frameGuide);url.searchParams.set('frameFamily',this.dataset.frameFamily);url.searchParams.set('part','frame');
   url.searchParams.set('profile',this.dataset.frameFamily==='wood'?'shutter-painted-wood':'shutter-hybrid');
  }else{url.searchParams.delete('frameGuide');url.searchParams.delete('frameFamily');}
  if(this.dataset.catalog)url.searchParams.set('catalog',this.dataset.catalog);else url.searchParams.delete('catalog');
  this.viewerOrigin=url.origin;this.fallback.href=url.href;
  // No iframe or renderer requests exist before this click.
  this.frame=document.createElement('iframe');this.frame.title=this.querySelector('.cce-dialog-header h2').textContent;this.frame.allow='fullscreen';this.frame.referrerPolicy='strict-origin-when-cross-origin';this.frame.src=url.href;this.host.append(this.frame);
  this.timer=setTimeout(()=>{if(this.loading.hidden)return;this.fallback.hidden=false;this.querySelector('.cce-spinner').hidden=true;this.querySelector('.cce-error').hidden=false;},20000);
 }
 cleanup(){
  clearTimeout(this.timer);this.frame?.remove();this.frame=null;
  if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
  if(this.opener?.isConnected)this.opener.focus();
 }
 disconnectedCallback(){this.dialog?.close();this.cleanup();this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-footer-slideshow')) {
  customElements.define('coverly-footer-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.cf-slide')];
      this.index = Math.max(0, this.slides.findIndex(slide => slide.hasAttribute('data-active')));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.inView = false;
      this.editorSelected = false;
      this.focused = false;
      this.hovered = false;
      if (this.slides.length < 2) return;
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { this.paused = this.dataset.autoplay !== 'true' || this.motion.matches; this.schedule(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.slideId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.show(index);
        this.schedule();
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        this.schedule();
      });
      this.observer.observe(this);
    }
    show(index) {
      this.slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
      this.index = index;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.inView || document.hidden || this.focused || this.hovered || this.editorSelected || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        const next = (this.index + 1) % this.slides.length;
        const img = this.slides[next].querySelector('img');
        if (!img || (img.complete && img.naturalWidth > 0)) this.show(next);
        this.schedule();
      }, Number(this.dataset.duration) || 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
if (!customElements.get('coverly-footer-signup')) {
  customElements.define('coverly-footer-signup', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      this.form = this.querySelector('form');
      this.email = this.querySelector('input[type="email"]');
      this.button = this.querySelector('button[type="submit"]');
      this.status = this.querySelector('.cf-crm-status');
      this.code = this.querySelector('.cf-crm-code');
      if (!this.form || !this.email || !this.button || !this.status) return;
      this.email.disabled = false;
      this.button.disabled = this.form.dataset.submitted === 'true';
      this.email.readOnly = this.form.dataset.submitted === 'true';
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.pending || this.form.dataset.submitted === 'true' || !this.form.reportValidity()) return;
        this.submit();
      }, { signal: this.listeners.signal });
    }
    connection() {
      const script = [...document.querySelectorAll('script[data-site]')].find(node => {
        try { return new URL(node.src, location.href).pathname.endsWith('/popup/p.js'); } catch { return false; }
      });
      const configUrl = this.dataset.configUrl?.trim() ? new URL(this.dataset.configUrl, location.href) : null;
      if (configUrl && !configUrl.pathname.endsWith('/api/popup/config')) throw new Error('Invalid CRM connection URL');
      const siteKey = configUrl ? configUrl.searchParams.get('site') : script?.getAttribute('data-site') || '';
      const configured = configUrl ? configUrl.origin + configUrl.pathname.slice(0, -17) : script?.getAttribute('data-base');
      const base = configured ? new URL(configured, location.href) : script ? new URL(new URL(script.src, location.href).origin) : null;
      if (configUrl && (configUrl.username || configUrl.password)) throw new Error('Invalid CRM connection URL');
      if (!siteKey || !base || base.protocol !== 'https:' || base.username || base.password) throw new Error('Missing CRM connection');
      base.search = '';
      base.hash = '';
      return { siteKey, apiBase: base.href.replace(/\/+$/, '') };
    }
    async request(url, options = {}) {
      const response = await fetch(url, { ...options, credentials: 'omit', signal: this.requestController.signal });
      const data = await response.json();
      if (!response.ok || !data || typeof data !== 'object') throw new Error('Signup request failed');
      return data;
    }
    async submit() {
      this.pending = true;
      this.button.disabled = true;
      this.email.readOnly = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.hidden = false;
      this.status.textContent = this.dataset.busy;
      this.status.setAttribute('role', 'status');
      this.email.setAttribute('aria-describedby', this.status.id);
      this.email.removeAttribute('aria-invalid');
      this.code.hidden = true;
      this.requestController = new AbortController();
      const timeout = setTimeout(() => this.requestController.abort(), 20000);
      try {
        const { siteKey, apiBase } = this.connection();
        const config = await this.request(`${apiBase}/api/popup/config?site=${encodeURIComponent(siteKey)}`);
        const campaign = Array.isArray(config.campaigns) ? config.campaigns.find(item => typeof item.id === 'string' && item.id) : null;
        if (!campaign) throw new Error('No active campaign');
        const utm = {};
        new URLSearchParams(location.search).forEach((value, key) => {
          if (/^utm_[a-z_]{1,40}$/i.test(key)) utm[key.toLowerCase()] = value.slice(0, 200);
        });
        const sessionId = this.sessionId || (this.sessionId = crypto.randomUUID());
        const data = await this.request(`${apiBase}/api/popup/lead`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            siteKey, campaignId: campaign.id, email: this.email.value.trim(),
            answers: { signup_source: 'footer' },
            context: {
              path: location.pathname.slice(0, 1000),
              pageUrl: (location.origin + location.pathname).slice(0, 1000),
              referrer: document.referrer.slice(0, 1000), utm,
              device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop', sessionId
            }
          })
        });
        if (!Object.hasOwn(data, 'code') || !data.successCopy) throw new Error('Unexpected signup response');
        this.status.textContent = this.dataset.success;
        this.form.dataset.submitted = 'true';
        if (typeof data.code === 'string' && data.code) {
          this.code.textContent = `${this.dataset.codeLabel} ${data.code}`;
          this.code.hidden = false;
        }
        this.dispatchEvent(new CustomEvent('coverly:newsletter-subscribed', { bubbles: true, detail: { source: 'footer' } }));
      } catch {
        if (this.isConnected) {
          this.status.textContent = this.dataset.error;
          this.status.setAttribute('role', 'alert');
          this.email.readOnly = false;
          this.button.disabled = false;
        }
      } finally {
        clearTimeout(timeout);
        this.pending = false;
        this.form.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.requestController?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-free-gifts"] && !Shopify.designMode) return;
  try {
    
"use strict";(()=>{var Q=Object.defineProperty;var J=(t,r,e)=>r in t?Q(t,r,{enumerable:!0,configurable:!0,writable:!0,value:e}):t[r]=e;var v=(t,r,e)=>J(t,typeof r!="symbol"?r+"":r,e);function B(t,r){let e=r.toISOString();return t.offers.filter(n=>n.enabled&&n.threshold!==null&&(!n.startsAt||n.startsAt<=e)&&(!n.endsAt||e<n.endsAt))}function H(t,r,e){let n=new Set(t.offers.map(a=>a.rewardProductId).filter(Boolean)),o=e.filter(a=>!n.has(a.productId)),i=(a,p)=>{let c=t.groups.find(f=>f.id===p);return!!c&&c.productIds.includes(a.productId)&&!c.excludedProductIds.includes(a.productId)};return r.combineGroups?o.filter(a=>r.qualifyingGroups.some(p=>i(a,p))).reduce((a,p)=>a+p.quantity,0):Math.max(0,...r.qualifyingGroups.map(a=>o.filter(p=>i(p,a)).reduce((p,c)=>p+c.quantity,0)))}function _(t,r){let e=new Set(t.offers.map(o=>o.rewardProductId).filter(Boolean)),n={};for(let o of t.groups)n[o.id]=r.filter(i=>!e.has(i.productId)&&o.productIds.includes(i.productId)&&!o.excludedProductIds.includes(i.productId)).reduce((i,a)=>i+a.quantity,0);return n}var Z=50;function X(t,r,e,n,o=new Date){if(new Set(t.offers.map(f=>f.rewardProductId).filter(Boolean)).has(e))return[];let a=(f,d)=>H(t,f,d>0?[...r,{key:"__product",productId:e,quantity:d}]:r),p=f=>{let d=t.groups.find(g=>g.id===f);return!!d&&d.productIds.includes(e)&&!d.excludedProductIds.includes(e)},c=Math.max(0,Math.floor(n)||0);return B(t,o).filter(f=>f.qualifyingGroups.some(p)).map(f=>{let d=f.threshold,g=a(f,0),l=a(f,c),y=g>=d?0:null;for(let b=1;y===null&&b<=Z;b++)a(f,b)>=d&&(y=b);let A=g>=d?"earned":l>=d?"unlocks":"more";return{offer:f,state:A,remaining:Math.max(0,d-l),before:g,unlockAt:y}}).sort((f,d)=>(f.unlockAt??1/0)-(d.unlockAt??1/0)||f.offer.displayOrder-d.offer.displayOrder||f.offer.id.localeCompare(d.offer.id))}function N(t){let r=new Map;for(let e of t)e.unlockAt!==null&&r.set(e.unlockAt,[...r.get(e.unlockAt)||[],e.offer]);return[...r].sort((e,n)=>e[0]-n[0]).map(([e,n])=>({add:e,offers:n}))}function z(t,r,e,n=new Date){let o=t.groups.find(a=>a.id===e),i=o?.productIds.find(a=>!o.excludedProductIds.includes(a));return i?X(t,r,i,0,n):[]}var R={shipping:"M3 7h11v10H3z M14 10h4l3 4v3h-7 M8 18a2 2 0 1 1-4 0a2 2 0 1 1 4 0 M20 18a2 2 0 1 1-4 0a2 2 0 1 1 4 0",price_lock:"M6 10h12v11H6z M8 10V6a4 4 0 0 1 8 0v4 M12 14v3",coverage:"M12 2l8 4v6c0 5-8 10-8 10S4 17 4 12V6z M8 12l3 3 5-6",gift:"M3 8h18v4H3z M5 12v9h14v-9 M12 8v13 M12 8S4 8 5 4s7 0 7 4c0-4 6-8 7-4s-7 4-7 4",badge:"M12 3a6 6 0 1 1 0 12a6 6 0 1 1 0-12 M9 14.2L7.5 21l4.5-2.5 4.5 2.5-1.5-6.8 M9.5 9l1.8 1.8L14.8 7.5"},tt={check:"M5 12.5l4.5 4.5L19 7.5",lock:"M7 11h10v9H7z M9 11V8a3 3 0 0 1 6 0v3",chevron:"M6 9l6 6 6-6",tag:"M3 12V4h8l10 10-8 8z M7.5 7.5h.01"};function $(t,r,e=r.layout){t.dataset.layout=e,t.dataset.size=r.size,t.dataset.corners=r.corners;for(let n of["accent","background","text","track"])t.style.setProperty("--offer-"+n,r[n]);t.style.setProperty("--offer-accent-base",r.accent)}function et(t,r=1.6){let e=document.createElementNS("http://www.w3.org/2000/svg","svg");e.setAttribute("viewBox","0 0 24 24"),e.setAttribute("fill","none"),e.setAttribute("stroke","currentColor"),e.setAttribute("stroke-width",String(r)),e.setAttribute("stroke-linecap","round"),e.setAttribute("stroke-linejoin","round"),e.setAttribute("aria-hidden","true");let n=document.createElementNS(e.namespaceURI,"path");return n.setAttribute("d",R[t]||tt[t]||R.gift),e.append(n),e}function rt(t){let r="http://www.w3.org/2000/svg",e=document.createElementNS(r,"svg");if(e.setAttribute("viewBox","0 0 24 24"),e.setAttribute("aria-hidden","true"),e.classList.add("co-uploaded-icon"),!t.tint){let o=document.createElementNS(r,"image");return o.setAttribute("href",t.url),o.setAttribute("width","24"),o.setAttribute("height","24"),o.setAttribute("preserveAspectRatio","xMidYMid meet"),e.append(o),e}let n=`url("${t.url.replace(/["\\]/g,encodeURIComponent)}") center / contain no-repeat`;return e.classList.add("co-uploaded-icon--tint"),e.style.setProperty("background-color","currentColor"),e.style.setProperty("-webkit-mask",n),e.style.setProperty("mask",n),e}function x(t,r,e,n){let o=t.icon||r.customIcons?.[t.kind];if(o)return rt(o);let i=e?.[t.kind];if(i){let a=document.createElement("template");a.innerHTML=i;let p=a.content.firstElementChild;if(p instanceof SVGSVGElement)return p.classList.add("co-set-icon"),p}return et(t.kind,n)}var G=(t,r)=>new Intl.NumberFormat(document.documentElement.lang||"en",{style:"currency",currency:r,...t%100===0?{minimumFractionDigits:0,maximumFractionDigits:0}:{}}).format(t/100),Y=t=>{let r=t.trim().split(/\s+/).pop().toLowerCase().replace(/s$/,"");return/^[a-z]+$/.test(r)?r:""},T=(t,r)=>t.discountType==="percentage"?`${t.discountValue}% off`:`${G(t.discountValue,r)} off`;function s(t,r,e){let n=document.createElement(t);return r&&(n.className=r),e!=null&&(n.textContent=e),n}var j=t=>/^[A-Z][a-z]*(?:[\s-]+[a-z0-9][\w'’-]*)*$/.test(t)?t[0].toLowerCase()+t.slice(1):t,O=(t,r)=>r===1?t:`${t}s`;function nt(t,r,e="item"){return t.valuePercent>0&&(t.kind==="coverage"||t.kind==="badge")?`Worth ${t.valuePercent}% of each ${e}'s price`:t.kind==="gift"||t.kind==="coverage"?t.unitPriceCents?`A ${G(t.unitPriceCents*(t.kind==="gift"?t.giftQuantity:1),r)} value${t.kind==="coverage"?" per item":""}`:"":t.kind==="price_lock"?`Your base price, locked for ${t.lockMonths} months`:t.kind==="badge"?"Included with your order":"Shipping on us"}function ot(t,r,e,n,o){let i=s("div","cfg-details");i.setAttribute("role","dialog"),i.setAttribute("aria-label",t.name);let a=s("div","cfg-details-head"),p=s("span","cfg-ico");p.dataset.state=r.state,p.append(x(t,n.appearance,n.config.icons,1.8));let c=s("button","cfg-x","\xD7");c.type="button",c.setAttribute("aria-label","Close"),c.onclick=d=>{d.stopPropagation(),o()},a.append(p,s("strong","",t.name),c),i.append(a);let f=nt(t,n.config.currency,e);return f&&i.append(s("p","cfg-value",f)),t.kind==="gift"&&t.discountValue>0&&i.append(s("p","cfg-or",`Or take ${T(t,n.config.currency)} instead \u2014 you choose in your cart.`)),i.append(s("p","cfg-status",r.state==="earned"?"Already in your cart":`${r.before>0?"Add":"Buy"} ${r.unlockAt} more ${O(e,r.unlockAt??0)} to get it`)),t.terms&&t.showTerms&&i.append(s("p","cfg-terms",t.terms)),i.onclick=d=>d.stopPropagation(),i}function st(t,r,e){let n=e.config.groups.find(c=>c.id===t.group),o=s("dialog","cfg-picker");o.setAttribute("aria-label",`Choose your ${r}`),$(o,e.appearance,"gifts");let i=s("div","cfg-picker-head");i.append(s("strong","",`Choose your ${r}`));let a=s("button","cfg-x","\xD7");if(a.type="button",a.setAttribute("aria-label","Close"),a.onclick=()=>o.close(),i.append(a),o.append(i),t.compareUrl){let c=s("a","cfg-compare");c.href=t.compareUrl,c.append(s("span","",`Not sure which ${r}?`),s("strong","",`${t.compareLabel||`Compare ${O(r,2)}`} \u2192`)),o.append(c)}let p=s("div","cfg-products");for(let c of n.productIds.filter(f=>!n.excludedProductIds.includes(f))){let f=e.config.products?.[c];if(!f)continue;let d=s("a","cfg-product");d.href=`${e.root}products/${f.h}`;let g=s("span","cfg-product-media");if(f.i){let l=s("img");l.src=f.i,l.alt="",l.loading="lazy",g.append(l)}d.append(g,s("span","cfg-product-title",f.t)),p.append(d)}return p.childElementCount||p.append(s("p","cfg-muted","Products are on their way \u2014 check back shortly.")),o.append(p),o.addEventListener("click",c=>{c.target===o&&o.close()}),o}function it(t,r,e){let n=e.config.groups.find(u=>u.id===t.group),o=Y(n.name)||"item",i=_(e.config,e.cart)[n.id]||0,a=s("section","cfg-group");a.dataset.group=n.id;let p=s("div","cfg-head");p.append(s("h2","cfg-title",t.heading||n.name));let c=r.find(u=>u.state==="more"&&u.unlockAt!==null),f=r.filter(u=>u.state==="earned"),d=s("p","cfg-progress");c?i?d.textContent=`You have ${i} ${O(o,i)} in your cart. ${c.unlockAt} more for ${j(c.offer.name)}.`:d.textContent=`Buy ${c.unlockAt} ${O(o,c.unlockAt)} for ${j(c.offer.name)}.`:d.textContent=f.length?`You\u2019ve earned every free gift for ${O(o,2)}.`:"",p.append(d),a.append(p);let g=N(r),l=s("ol","cfg-steps"),y=s("li","cfg-step cfg-start");y.dataset.state="start";let A=s("span","cfg-dot",String(i));y.append(A,s("span","cfg-step-n","Your cart"),s("span","cfg-step-sub",i?`${i} ${O(o,i)}`:"Empty")),l.append(y),g.forEach(u=>{let C=u.add===0?"earned":"more",k=s("li","cfg-step");k.dataset.state=C;let U=s("span","cfg-dot");u.offers.slice(0,3).forEach((m,L)=>{let h=s("span","cfg-ico");h.dataset.state=C,h.style.setProperty("--i",String(L)),h.append(x(m,e.appearance,e.config.icons,1.8)),U.append(h)}),k.append(U,s("span","cfg-step-n",u.add===0?"Yours":`${i?"Add":"Buy"} ${u.add}`));let q=s("span","cfg-gifts");for(let m of u.offers){let L=r.find(I=>I.offer.id===m.id),h=`${n.id}:${m.id}`,E=s("span","cfg-gift-wrap"),w=s("button","cfg-gift");w.type="button",w.setAttribute("aria-expanded",String(e.state.open===h)),w.append(s("span","cfg-gift-name",m.name)),m.kind==="gift"&&m.discountValue>0&&w.append(s("span","cfg-gift-or",`or ${T(m,e.config.currency)}`)),w.onclick=I=>{I.stopPropagation(),e.state.open=e.state.open===h?void 0:h,e.redraw()},E.append(w),e.state.open===h&&E.append(ot(m,L,o,e,()=>{e.state.open=void 0,e.redraw()})),q.append(E)}k.append(q),l.append(k)});let b=g.filter(u=>u.add===0).length,D=i&&c&&c.unlockAt?Math.min(1,c.before/(c.before+c.unlockAt)):0;[...l.children].forEach((u,C)=>{let k=u;C!==l.children.length-1&&(k.dataset.link=C<b?"full":C===b&&D>0?"partial":"none",k.style.setProperty("--p",String(D)))}),a.append(l);let M=s("div","cfg-actions"),P=s("button","cfg-primary",e.buttonLabel||"Start adding");P.type="button";let S=st(t,o,e);if(P.onclick=()=>{typeof S.showModal=="function"?S.showModal():S.setAttribute("open","")},M.append(P),t.compareUrl){let u=s("a","cfg-secondary",t.compareLabel||`Compare ${O(o,2)}`);u.href=t.compareUrl,M.append(u)}return a.append(M,S),a}function K(t){let r=s("div","cfg");$(r,t.appearance,"gifts");let e=t.groups.length?t.groups:t.config.groups.map(o=>({group:o.id})),n=0;for(let o of e){if(!t.config.groups.some(a=>a.id===o.group))continue;let i=z(t.config,t.cart,o.group);i.length&&(r.append(it(o,i,t)),n++)}return n||r.append(s("p","cfg-empty",t.emptyText||"No free gifts are running right now. Check back soon.")),r}var W=()=>window.Shopify?.routes?.root||"/",F=t=>{try{return JSON.parse(t?.textContent||"null")}catch{return null}},V=class extends HTMLElement{constructor(){super(...arguments);v(this,"config",null);v(this,"settings",{groups:[],button:"",empty:""});v(this,"cart",[]);v(this,"state",{})}connectedCallback(){this.config=F(this.querySelector("script[data-offers]")),this.settings=F(this.querySelector("script[data-settings]"))||this.settings;let e=()=>void this.load();typeof subscribe=="function"&&typeof PUB_SUB_EVENTS<"u"&&subscribe(PUB_SUB_EVENTS.cartUpdate,e),document.addEventListener("cart:updated",e),document.addEventListener("visibilitychange",()=>{document.hidden||e()}),document.addEventListener("click",()=>{this.state.open&&(this.state.open=void 0,this.draw())}),document.addEventListener("keydown",n=>{n.key==="Escape"&&this.state.open&&(this.state.open=void 0,this.draw())}),this.draw(),e()}async load(){try{let e=await(await fetch(W()+"cart.js",{headers:{Accept:"application/json"}})).json(),n=this.config?.rewardProductIds||[];this.cart=e.items.filter(o=>!n.includes(String(o.product_id))).map(o=>({key:o.key,productId:String(o.product_id),quantity:o.quantity}))}catch{}this.draw()}draw(){let e=this.querySelector("[data-gifts-body]");if(!e)return;let n=this.config,o=n?.appearance,i=!!n&&!!o?.productDesktop&&n.validUntilEpoch>Date.now()&&!(n.previewOnly&&window.Shopify?.theme?.role==="main");e.replaceChildren(K({config:i?n:{groups:[],offers:[],currency:"USD"},appearance:o||{},cart:this.cart,groups:this.settings.groups,buttonLabel:this.settings.button,emptyText:this.settings.empty,state:this.state,redraw:()=>this.draw(),root:W()}))}};customElements.get("coverly-free-gifts")||customElements.define("coverly-free-gifts",V);})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-home-heroes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('coverly-hero-slideshow'))customElements.define('coverly-hero-slideshow',class extends HTMLElement{
 connectedCallback(){queueMicrotask(()=>{if(this.isConnected)this.initialize()})}
 initialize(){
  this.slides=[...this.querySelectorAll('[data-slide]')];this.buttons=[...this.querySelectorAll('[data-go]')];
  this.abort=new AbortController();const on=(el,event,fn)=>el.addEventListener(event,e=>{fn(e);this.syncAnimation?.()},{signal:this.abort.signal});
  const sizeHero=()=>{const top=Math.max(0,this.getBoundingClientRect().top+window.scrollY);this.style.setProperty('--hero-top-offset',`${top}px`)};
  sizeHero();on(window,'resize',sizeHero);on(window,'load',sizeHero);
  this.headerObserver=new ResizeObserver(sizeHero);document.querySelectorAll('.shopify-section-group-header-group').forEach(el=>this.headerObserver.observe(el));
  if(this.slides.length<2)return;
  this.fills=this.buttons.map(b=>b.querySelector('.chs-fill'));this.index=0;this.elapsed=0;this.last=0;this.duration=Number(this.dataset.duration)||6000;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;this.hover=false;this.focus=false;this.visible=true;
  this.querySelector('[data-controls]').hidden=false;
  this.buttons.forEach((b,i)=>on(b,'click',()=>this.show(i)));

  on(this,'pointerenter',e=>{if(e.pointerType==='mouse')this.hover=true});on(this,'pointerleave',()=>this.hover=false);
  on(this,'focusin',()=>this.focus=true);on(this,'focusout',e=>this.focus=this.contains(e.relatedTarget));
  on(this,'pointerdown',e=>{this.startX=e.clientX;this.startY=e.clientY});on(this,'pointerup',e=>{const x=e.clientX-this.startX,y=e.clientY-this.startY;if(Math.abs(x)>60&&Math.abs(x)>Math.abs(y)*1.5)this.show(this.index+(x<0?1:-1))});
  on(this,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1))}});
  on(document,'visibilitychange',()=>this.last=0);on(this.motion,'change',()=>{this.paused=this.motion.matches});
  on(document,'shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.show(i);this.paused=true}});
  on(document,'shopify:block:deselect',()=>{this.paused=this.motion.matches});
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.syncAnimation()});this.observer.observe(this);
  this.canAnimate=()=>!this.paused&&!this.hover&&!this.focus&&!document.hidden&&this.visible;
  this.syncAnimation=()=>{if(this.canAnimate()){if(!this.raf){this.last=0;this.raf=requestAnimationFrame(this.tick)}}else{cancelAnimationFrame(this.raf);this.raf=0;this.last=0}};
  this.tick=time=>{this.raf=0;if(!this.canAnimate()){this.last=0;return}if(this.last){this.elapsed+=time-this.last;if(this.elapsed>=this.duration)this.show(this.index+1);this.fills[this.index].style.transform=`scaleX(${this.elapsed/this.duration})`}this.last=time;this.raf=requestAnimationFrame(this.tick)};this.paint();this.syncAnimation();
 }

 paint(){this.buttons.forEach((b,i)=>b.querySelector('.chs-fill').style.transform=`scaleX(${i===this.index?this.elapsed/this.duration:0})`)}
 show(i){this.index=(i+this.slides.length)%this.slides.length;this.elapsed=0;this.last=0;this.slides.forEach((s,n)=>{s.hidden=n!==this.index;s.inert=n!==this.index;s.classList.toggle('is-active',n===this.index)});this.buttons.forEach((b,n)=>{if(n===this.index)b.setAttribute('aria-current','true');else b.removeAttribute('aria-current')});this.paint()}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.headerObserver?.disconnect();cancelAnimationFrame(this.raf)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-motor-connections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-motor-connections')) {
  customElements.define('coverly-motor-connections', class extends HTMLElement {
    connectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = new AbortController();
      const options = { signal: this.lifecycle.signal };
      const tabs = () => [...this.querySelectorAll('[data-cmn-tab]')];
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-cmn-tab]');
        if (tab && this.contains(tab)) this.select(tab.dataset.cmnTab);
      }, options);
      // Arrow keys move between tabs (Home/End jump), as for any tab list.
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-cmn-tab]');
        if (!tab) return;
        const all = tabs(), i = all.indexOf(tab);
        const next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: all.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        const target = all[(next + all.length) % all.length];
        this.select(target.dataset.cmnTab);
        target.focus();
      }, options);
      // Theme editor: picking a connection or device block opens its tab.
      this.addEventListener('shopify:block:select', (event) => {
        const row = event.target.closest('[data-cmn-row]');
        if (row && this.contains(row)) this.select(row.dataset.cmnRow);
      }, options);
    }

    select(id) {
      this.querySelectorAll('[data-cmn-tab]').forEach((tab) => {
        const on = tab.dataset.cmnTab === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) tab.removeAttribute('tabindex'); else tab.setAttribute('tabindex', '-1');
      });
      this.querySelectorAll('[data-cmn-row]').forEach((row) => { row.hidden = row.dataset.cmnRow !== id; });
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-review-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coverly-review-gallery')) {
  customElements.define('coverly-review-gallery', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.abort) this.init(); });
    }
    init() {
      this.abort = new AbortController();
      this.grid = this.querySelector('.crg-grid');
      this.columns = [...this.querySelectorAll('[data-crg-column]')];
      this.tiles = [...this.querySelectorAll('[data-crg-tile]')];
      this.media = matchMedia('(max-width:989px)');
      this.media.addEventListener('change', () => this.layout(), {signal:this.abort.signal});
      this.layout();
    }
    layout() {
      const mobile = this.media.matches;
      const order = tile => mobile && Number(tile.dataset.mobileOrder) > 0 ? Number(tile.dataset.mobileOrder) : Number(tile.dataset.order);
      const tiles = [...this.tiles].sort((a,b) => order(a) - order(b) || Number(a.dataset.order) - Number(b.dataset.order));
      for (const tile of tiles) {
        const target = Number(mobile ? tile.dataset.mobileColumn : tile.dataset.desktopColumn) || 1;
        this.columns[Math.max(0, Math.min((mobile ? 2 : 4) - 1, target - 1))].append(tile);
      }
      this.columns.forEach(column => { column.hidden = !column.children.length; });
      this.grid.style.setProperty('--crg-columns', Math.max(1, this.columns.filter(column => !column.hidden).length));
      this.setAttribute('data-crg-ready','');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-shade-us-them"] && !Shopify.designMode) return;
  try {
    
(() => {
  class CoverlyShadeVersus extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); this.video?.pause(); }
    init() {
      this.abort?.abort(); this.observer?.disconnect(); this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('video'); this.button = this.querySelector('[data-versus-playback]');
      if (!this.video || !this.button) return;
      this.video.muted = true; this.video.defaultMuted = true;
      this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsPlayback = this.dataset.autoplay === 'true' && !this.mediaQuery.matches;
      this.inView = false; this.button.hidden = false;
      const showState = () => {
        const playing = !this.video.paused && !this.video.ended;
        this.video.classList.toggle('is-playing', playing);
        this.button.querySelector('[data-playback-label]').textContent = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
        this.button.querySelector('[data-play-icon]').toggleAttribute('hidden', playing);
        this.button.querySelector('[data-pause-icon]').toggleAttribute('hidden', !playing);
      };
      this.updatePlayback = () => {
        if (!this.isConnected || !this.wantsPlayback || !this.inView || document.hidden) { this.video.pause(); return; }
        if (this.video.paused) this.video.play().then(() => {
          if (!this.isConnected || !this.wantsPlayback || !this.inView || document.hidden) this.video.pause();
          showState();
        }).catch(() => showState());
      };
      this.button.addEventListener('click', () => { this.wantsPlayback = this.video.paused; this.updatePlayback(); }, {signal});
      this.video.addEventListener('playing', showState, {signal});
      this.video.addEventListener('pause', showState, {signal});
      this.video.addEventListener('error', () => { this.video.pause(); showState(); this.button.hidden = true; }, {signal});
      this.mediaQuery.addEventListener('change', () => { if (this.mediaQuery.matches) this.wantsPlayback = false; this.updatePlayback(); }, {signal});
      document.addEventListener('visibilitychange', () => this.updatePlayback(), {signal});
      this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.updatePlayback(); }, {threshold:0});
      this.observer.observe(this); showState();
    }
  }
  if (!customElements.get('coverly-shade-us-them')) customElements.define('coverly-shade-us-them', CoverlyShadeVersus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-split-products"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('coverly-split-products')) {
  customElements.define('coverly-split-products', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.init(); });
    }
    init() {
      this.rail = this.querySelector('[data-rail]');
      this.items = [...this.querySelectorAll('[data-item]:not([data-clone])')];
      if (!this.rail || !this.items.length || this.abort) return;
      this.abort = new AbortController();
      this.index = 0;
      this.targetIndex = null;
      this.dots = [...this.querySelectorAll('[data-dot]')];
      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this.abort.signal });
      this.items.forEach((item, index) => { item.dataset.productIndex = index; });
      if (this.items.length > 1) {
        const prefixClones = this.items.slice(-2).map(item => this.makeClone(item));
        const suffixClones = this.items.slice(0,2).map(item => this.makeClone(item));
        this.rail.prepend(...prefixClones);
        this.rail.append(...suffixClones);
        this.querySelectorAll('[data-prev],[data-next],[data-dots]').forEach(el => { el.hidden = false; });
      }
      this.slides = [...this.rail.children];
      on(this.querySelector('[data-prev]'), 'click', () => this.go((this.targetIndex ?? this.index) - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.go((this.targetIndex ?? this.index) + 1));
      this.dots.forEach((button, index) => on(button, 'click', () => this.go(index)));
      on(this.rail, 'keydown', event => {
        let target;
        if (event.key === 'ArrowLeft') target = (this.targetIndex ?? this.index) - 1;
        if (event.key === 'ArrowRight') target = (this.targetIndex ?? this.index) + 1;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.items.length - 1;
        if (target !== undefined) { event.preventDefault(); this.go(target); }
      });
      on(this.rail, 'scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
        this.queueSettle();
      });
      on(this.rail, 'scrollend', () => { if (!this.pointerDown) this.settle(); });
      on(this.rail, 'pointerdown', () => { this.pointerDown = true; });
      const release = () => { this.pointerDown = false; this.queueSettle(); };
      on(window, 'pointerup', release);
      on(window, 'pointercancel', release);
      this.resize = new ResizeObserver(() => {
        const width = this.rail.clientWidth;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.jump(this.targetIndex ?? this.index);
        }
        this.positionArrows();
      });
      this.resize.observe(this.rail);
      this.items.forEach(item => this.resize.observe(item.querySelector('.ccard__media')));
      this.content = new MutationObserver(records => {
        const changed = new Set(records.map(record => record.target.parentElement?.closest('[data-item]') || record.target.closest?.('[data-item]')));
        for (const item of changed) {
          if (!item || item.hasAttribute('data-clone')) continue;
          this.slides.filter(slide => slide.hasAttribute('data-clone') && slide.dataset.productIndex === item.dataset.productIndex).forEach(slide => {
            const fresh = this.makeClone(item);
            slide.replaceChildren(...fresh.childNodes);
          });
        }
      });
      this.items.forEach(item => this.content.observe(item.querySelector('.ccard'), { subtree: true, childList: true, attributes: true, attributeFilter: ['src','srcset','alt','href','aria-pressed','data-photo-missing'] }));
      this.setAttribute('data-loop-ready','');
      this.jump(0);
      on(document.fonts, 'loadingdone', () => this.positionArrows());
      document.fonts.ready.then(() => { if (this.isConnected) this.positionArrows(); });
    }
    makeClone(item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-clone','');
      clone.setAttribute('aria-hidden','true');
      clone.inert = true;
      clone.querySelectorAll('script').forEach(el => el.remove());
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      return clone;
    }
    offset(slide) {
      const box = slide.getBoundingClientRect(), rail = this.rail.getBoundingClientRect();
      return this.rail.scrollLeft + box.left + box.width / 2 - rail.left - this.rail.clientWidth / 2;
    }
    nearest() {
      return this.slides.reduce((best, slide) => Math.abs(this.offset(slide) - this.rail.scrollLeft) < Math.abs(this.offset(best) - this.rail.scrollLeft) ? slide : best, this.slides[0]);
    }
    update() {
      const active = this.nearest();
      this.index = Number(active.dataset.productIndex);
      this.slides.forEach(slide => {
        const selected = slide === active;
        slide.classList.toggle('is-active',selected);
        if (!slide.hasAttribute('data-clone')) {
          if (!selected && slide.contains(document.activeElement)) this.rail.focus({preventScroll:true});
          slide.inert = !selected;
          if (selected) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden','true');
        }
      });
      this.dots.forEach((dot,index) => {
        if (index === this.index) dot.setAttribute('aria-current','true');
        else dot.removeAttribute('aria-current');
      });
      this.positionArrows();
    }
    positionArrows() {
      const media = this.items[this.index]?.querySelector('.ccard__media');
      if (!media) return;
      const box = media.getBoundingClientRect(), viewport = this.querySelector('.csp-viewport').getBoundingClientRect();
      this.style.setProperty('--csp-image-center',`${box.top + box.height / 2 - viewport.top}px`);
    }
    jump(index) {
      if (!this.items?.length) return;
      this.index = (index + this.items.length) % this.items.length;
      this.targetIndex = null;
      this.rail.scrollTo({left:this.offset(this.items[this.index]),behavior:'instant'});
      this.update();
    }
    go(index) {
      const count = this.items.length;
      if (count < 2) return;
      if (this.targetIndex !== null) this.jump(this.targetIndex);
      const target = ((index % count) + count) % count;
      const matches = this.slides.filter(slide => Number(slide.dataset.productIndex) === target);
      const activeOffset = this.rail.scrollLeft;
      const direction = index < this.index ? -1 : 1;
      matches.sort((a,b) => {
        const da = this.offset(a) - activeOffset, db = this.offset(b) - activeOffset;
        const score = d => Math.abs(d) + (Math.sign(d) === direction ? 0 : 0.1);
        return score(da) - score(db);
      });
      this.targetIndex = target;
      this.rail.scrollTo({left:this.offset(matches[0]),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      this.queueSettle();
    }
    queueSettle() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { if (!this.pointerDown) this.settle(); },150);
    }
    settle() {
      clearTimeout(this.timer);
      if (!this.isConnected) return;
      const active = this.nearest();
      const index = Number(active.dataset.productIndex);
      this.targetIndex = null;
      if (active.hasAttribute('data-clone')) this.jump(index);
      else this.update();
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = this.items[index].querySelector('.ccard__title')?.textContent.trim() || '';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      this.content?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.querySelectorAll('[data-clone]').forEach(el => el.remove());
      this.items?.forEach(item => { item.inert = false; item.removeAttribute('aria-hidden'); item.classList.remove('is-active'); });
      this.removeAttribute('data-loop-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coverly-stats-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-stats-banner')) {
    customElements.define('coverly-stats-banner', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.queueFit = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fitText());
        };
        this.resizeObserver = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width !== this.lastWidth) {
            this.lastWidth = entry.contentRect.width;
            this.queueFit();
          }
        });
        this.resizeObserver.observe(this);
        this.contentObserver = new MutationObserver(this.queueFit);
        this.contentObserver.observe(this, { childList: true, subtree: true, characterData: true });
        window.addEventListener('resize', this.queueFit, { signal: this.abort.signal });
        document.fonts.addEventListener('loadingdone', this.queueFit, { signal: this.abort.signal });
        document.fonts.ready.then(() => { if (this.isConnected) this.queueFit(); });
        this.queueFit();
      }
      fitText() {
        if (!this.isConnected || this.clientWidth === 0) return;
        this.style.removeProperty('--csb-heading-fit');
        this.style.removeProperty('--csb-subtext-fit');
        let groupWidth = 0;
        for (const item of this.querySelectorAll('.csb-item')) {
          const style = getComputedStyle(item);
          const textWidths = [...item.querySelectorAll('.csb-heading span, .csb-subtext span')]
            .filter(span => getComputedStyle(span).display !== 'none')
            .map(span => span.getBoundingClientRect().width);
          const width = Math.ceil(Math.max(0, ...textWidths) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 2);
          item.style.setProperty('--csb-item-width', `${width}px`);
          groupWidth += width;
        }
        this.style.setProperty('--csb-natural-width', `${groupWidth}px`);
        for (const kind of ['heading', 'subtext']) {
          const rows = [...this.querySelectorAll(`[data-csb-${kind}]`)];
          let scale = 1;
          for (const row of rows) {
            const text = [...row.children].find(span => getComputedStyle(span).display !== 'none');
            if (text && text.getBoundingClientRect().width > 0) {
              scale = Math.min(scale, Math.max(1, row.clientWidth - 2) / text.getBoundingClientRect().width);
            }
          }
          if (rows.length && scale < 1) {
            const size = parseFloat(getComputedStyle(rows[0]).fontSize);
            this.style.setProperty(`--csb-${kind}-fit`, `${Math.floor(size * scale * 10) / 10}px`);
          }
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
        this.resizeObserver?.disconnect();
        this.contentObserver?.disconnect();
        this.lastWidth = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-portal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coverly-customer-portal')) {
    customElements.define('coverly-customer-portal', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const frame = this.querySelector('iframe');
        if (!frame) return;
        let url;
        try { url = new URL(this.dataset.portalUrl); } catch { return; }
        if (url.protocol !== 'https:' || url.username || url.password) return;
        const incoming = new URLSearchParams(window.location.hash.slice(1));
        const launch = new URLSearchParams();
        // Passed through to the portal: sign-in link, order to open, and the order-update
        // unsubscribe link (opens Email preferences). Nothing else from the page URL reaches it.
        for (const key of ['access', 'order', 'unsubscribe']) {
          if (incoming.get(key)) launch.set(key, incoming.get(key));
        }
        const external = new URL(url);
        external.hash = launch.toString();
        const fallback = this.querySelector('a');
        if (fallback) fallback.href = external.href;
        url.searchParams.set('embed', '1');
        url.hash = launch.toString();
        if (launch.size) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        // The portal reports its height in embed mode. "Fill the page": the frame is at least the
        // screen below the header and grows to its content with no cap, so the page scrolls instead of
        // a box inside it. Otherwise it grows up to the "Maximum height" setting. Messages from any
        // other frame or origin are ignored.
        const fill = this.dataset.fill === 'true';
        const cap = fill ? 20000 : (Number(this.dataset.maxHeight) || 800);
        let content = 0;
        const floor = () => fill ? Math.max(420, Math.round(window.innerHeight - (frame.getBoundingClientRect().top + window.scrollY))) : 420;
        const size = () => {
          const height = Math.min(Math.max(content, floor()), cap);
          frame.style.height = height + 'px';
        };
        window.addEventListener('message', (event) => {
          if (event.source !== frame.contentWindow) return;
          if (event.origin !== url.origin) return;
          const data = event.data;
          if (!data || data.type !== 'coverly-portal:height') return;
          content = Number(data.height) || 0;
          size();
        });
        window.addEventListener('resize', size);
        size();
        frame.src = url.href;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
